var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"ct",staticClass:"hbox-container",class:_vm.params.className,style:({padding:_vm.params.padding})},[_c('div',{staticClass:"handler"}),_vm._v(" "),_vm._l((_vm.params.columns),function(col,index){return _c('div',{key:index,ref:"columns",refInFor:true,staticClass:"hbox-column dragula-container",class:{'fit-height':!_vm.params.dynamicHeight}})})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f7cbb900","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/extend/layout/designer/hbox-designer.vue
// module id = 795
// module chunks = 0 1